import { render } from "./configuracion.vue?vue&type=template&id=cfb4f7a6"
import script from "./configuracion.vue?vue&type=script&lang=js"
export * from "./configuracion.vue?vue&type=script&lang=js"
script.render = render

export default script